package com.trevorwiebe.timesheet.mileage.domain.model

enum class EquipmentType { TRUCK, TRAILER }

data class Equipment(
    val id: String,
    val unitNumber: String,
    val type: EquipmentType,
    val active: Boolean,
    val serviceInterval: Long,
    val serviceWarningMiles: Long,
    val deleted: Boolean
)

fun Equipment.isServiceDue(milesSinceService: Long): Boolean =
    serviceInterval != 0L && milesSinceService >= serviceInterval - serviceWarningMiles

/** Orders unit numbers numerically ("2" before "10"); non-numeric units follow, alphabetically. */
val unitNumberOrder: Comparator<String> =
    compareBy<String>({ it.trim().toLongOrNull() == null }, { it.trim().toLongOrNull() }, { it })
